module.exports = __webpack_public_path__ + "static/media/parallax-form-5.d2049c56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/common/parallax/parallax-form-5.svg
// module id = 1728
// module chunks = 147